import { TemplatePage } from './types';

const live_streaming_christmas_theme: TemplatePage = {
  header: {
    color: '#F1F6FA',
    icon: 'images/video-templates/christmas.jpg',
    title: 'Live Stream Templates — Christmas Sweater Theme',
    title_meta: 'Free Christmas Sweater Live Stream Overlay Templates',
    description_meta:
      'Set a festive tone for your live stream with customizable holiday-themed overlay templates.' +
      ' Try them now — easy & free!',
    description:
      'Set a festive tone for your live stream with our collection of customizable holiday-themed' +
      ' overlay templates. Create a jolly thumbnail, countdown, intro & outro, and lower third for ' +
      ' your live stream with minimum effort.'
  },
  footer: {
    category: 'Live Stream Christmas Sweater Theme',
    description:
      'With Wave.video’s festive collection of easy-to-customize templates, you can create pro-looking' +
      ' branded live stream overlays and screens in a matter of a few clicks. Mesmerize your online' +
      ' audience with with beautiful Christmas-themed thumbnails, countdowns, intros, outros, and lower thirds — no' +
      ' special design skills needed. Take your live streaming to the next level this holiday season and' +
      ' immediately reap the rewards of your efforts!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Christmas Sweater Theme',
      search: { name: 'ChristmasSweaterTheme', tags: 'ChristmasSweaterTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_christmas_theme;
